export default function rightMenuSupplier(ctx) {
  return [
    {
      name: ctx.$gettext('My interpreter ID'),
      type: 'button',
      classNames: 'header__subnav-link header__subnav-link--interpreter-id',
      action: 'openInterpreterIdModal',
      condition: !ctx.isCourtTheme && !ctx.isTranslationOnly,
    },
    {
      name: ctx.$gettext('Documents'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--documents',
      action: !ctx.isCourtTheme ? ctx.$makeRoute({name: 'ServerDocuments'}) : ctx.$makeRoute({name: 'ServerCertificates'}),
      condition: true,
    },
    {
      name: ctx.$gettext('Payout preferences'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--payout-preferences',
      action: ctx.$makeRoute({name: 'ServerPayoutsAll'}),
      condition: !ctx.isCourtTheme,
    },
    {
      name: ctx.$gettext('Change password'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--password',
      action: ctx.$makeRoute({name: 'ServerChangePassword'}),
      condition: true,
    },
    {
      name: ctx.$gettext('Settings'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--settings',
      action: ctx.settingsLink,
      condition: true,
    },
    {
      name: ctx.$gettext('Accessibility'),
      type: 'button',
      classNames: 'header__subnav-link header__subnav-link--accessibility',
      action: 'openAccessibilityModal',
      condition: true,
    },
    {
      name: ctx.$gettext('Video test'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--video-test',
      action: ctx.$makeRoute({name: 'ServerTestVideo'}),
      condition: !ctx.isTranslationOnly,
    },
    {
      name: '',
      type: 'lang-selector',
      classNames: '',
      condition: ctx.isMobileView,
    },
    {
      name: ctx.$gettext('Help'),
      type: 'link',
      classNames: 'header__subnav-link header__subnav-link--help-link',
      href: 'https://support.salita.no/collection/380-tolkebruker',
      target: '_blank',
      condition: ctx.isMobileView,
    },
    {
      name: ctx.$gettext('Sign out'),
      type: 'button',
      classNames: 'header__subnav-link header__subnav-link--sign-out',
      action: 'logOut',
      condition: true,
    },
  ];
}
